/**
 * @generated SignedSource<<e1cf7e813f1324bc7b10350336343d5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowWithSiblingCreate_issueOld$data = {
  readonly id: string;
  readonly issueId: string;
  readonly " $fragmentSpreads": FragmentRefs<"RowMaybeWithDragAndDrop_issueOld">;
  readonly " $fragmentType": "RowWithSiblingCreate_issueOld";
};
export type RowWithSiblingCreate_issueOld$key = {
  readonly " $data"?: RowWithSiblingCreate_issueOld$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowWithSiblingCreate_issueOld">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowWithSiblingCreate_issueOld",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isLinkRelationshipFieldEnabled",
          "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
          "kind": "Variable",
          "name": "isRemoteLinkedIssuesEnabled",
          "variableName": "isRemoteLinkedIssuesEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RowMaybeWithDragAndDrop_issueOld"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "issueId"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "ad6139c8e359e0ce6e91f6af407ec726";

export default node;
